import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

// ARCHIVO CONFIG VISUAL PRIMENG
const GomezPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#E6FFF2',
      100: '#C2FFD9',
      200: '#99FFC2',
      300: '#66FFA8',
      400: '#33FF8A',
      500: '#00C95D',
      600: '#00B352',
      700: '#009944',
      800: '#007F38',
      900: '#00662D',
      950: '#004D22',
    },
    secondary: {
      50: '#F4F5F6',
      100: '#E4E6E9',
      200: '#C9CED3',
      300: '#A4ADB6',
      400: '#7B8894',
      500: '#1D2932',
      600: '#1A252D',
      700: '#161F26',
      800: '#121A1F',
      900: '#0E1419',
      950: '#090D10',
    },
    borderRadius: {
      none: '0',
      xs: '2px',
      sm: '4px',
      md: '6px', // Este suele ser el estándar de PrimeNG
      lg: '8px',
      xl: '12px',
    },
    components: {
      button: {
        borderRadius: '6px',
        secondary: {
          background: '#1D2932',
          borderColor: '#1D2932',
          color: '#ffffff',
          hoverBackground: '#121A1F',
          activeBackground: '#0E1419',
        },
      },
      inputtext: {
        borderRadius: '6px',
      },
    },
  },
});

export default GomezPreset;
